export function formatDateTime(value) {
  if (!value) return null;
  const [datePart, timePart] = value.split("T");
  const [year, month, day] = datePart.split("-");
  const [hour, minute] = timePart.split(":");

  return {
    datetime: `${day}/${month}/${year} ${hour}:${minute}`,
  };
}
